// src/pages/MasjidPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/MasjidPage.css";
import PageBackBar from "../components/PageBackBar";
import { shuffleArray, seededShuffleArray, daySeed } from "../utils/arrayUtils";
import { getCachedPublicMasjids, loadPublicMasjids } from "../services/publicMasjidCatalog";


const norm = (s = "") => String(s || "").trim();

export default function MasjidPage() {
    const navigate = useNavigate();
    const [masjids, setMasjids] = useState([]);
    const [activeTab, setActiveTab] = useState("Semua");

    const getSlug = (m) => m.slug || m.profail?.slug || "";
    const getNegeri = (m) => norm(m.profail?.negeri || m.negeri || "Lain-lain") || "Lain-lain";

    // cache first
    useEffect(() => {
        const rows = getCachedPublicMasjids();
        if (rows.length) setMasjids(seededShuffleArray(rows, daySeed()));
    }, []);


    // firestore latest
    useEffect(() => {
        let active = true;
        loadPublicMasjids()
            .then((rows) => {
                if (active) setMasjids(shuffleArray(rows));
            })
            .catch((err) => console.error("❌ load masajid error:", err));
        return () => { active = false; };
    }, []);

    const tabs = useMemo(() => {
        const set = new Set();
        masjids.forEach((m) => set.add(getNegeri(m)));
        return ["Semua", ...Array.from(set).sort((a, b) => a.localeCompare(b))];
    }, [masjids]);

    useEffect(() => {
        if (!tabs.includes(activeTab)) setActiveTab("Semua");
    }, [tabs, activeTab]);

    const list = useMemo(() => {
        if (activeTab === "Semua") return masjids;
        return masjids.filter((m) => getNegeri(m) === activeTab);
    }, [masjids, activeTab]);

    const openMosque = (m) => {
        const slug = getSlug(m);
        if (!slug) return;
        navigate(`/${slug}`, { state: { from: "masjid" } });
    };

    return (
        <div className="masjid-page">

            <PageBackBar title="Masjid" />


            {/* <div className="masjid-tabs">
                {tabs.map((t) => (
                    <button
                        key={t}
                        type="button"
                        className={`masjid-tab ${activeTab === t ? "active" : ""}`}
                        onClick={() => setActiveTab(t)}
                    >
                        {t}
                    </button>
                ))}
            </div> */}

            {list.length === 0 ? (
                <div className="masjid-empty">Tiada masjid dalam negeri ini.</div>
            ) : (
                <div className="masjid-grid">
                    {list.map((m) => {
                        const slug = getSlug(m);
                        const clickable = Boolean(slug);
                        const name = m.name || m.profail?.nama || m.id;
                        const logo = m.photo_src || m.profail?.logo || m.profail?.logoJa || "";

                        return (
                            <button
                                key={m.id}
                                type="button"
                                // className={`masjid-card2 ${clickable ? "" : "disabled"}`}
                                className={`masjid-card2`}

                                onClick={clickable ? () => openMosque(m) : undefined}
                                title={clickable ? "Buka halaman masjid" : "Belum ada halaman"}
                            >
                                {logo ? (
                                    <img className="masjid-logo2" src={logo} alt={name} onError={(e) => (e.currentTarget.style.display = "none")} />
                                ) : (
                                    <div className="masjid-logo2 fallback" />
                                )}
                                <div className="masjid-name2">{name}</div>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
